export default "__VITE_ASSET__8qTWXz6s__"